import VeiculoService from "../../../services/VeiculoService";
import { observable, toJS } from "mobx";


export default class VeiculoStore {

    @observable dadosTransportes;

    @observable totalPlacas;

    @observable listaClientes;
    @observable listaTranportadoras;

    @observable placa;
    @observable transpId;
    @observable clienteId;

    @observable loadingVeiculos;
    
    constructor() {

        this.dadosTransportes = null
        this.totalPlacas = 0
        this.listaClientes = [];
        this.listaTranportadoras = [];
        
        this.placa = ""
        this.transpId = ""
        this.clienteId = ""

        this.loadingVeiculos = false

        this.service = new VeiculoService()

        this.listar()
        this.listarClientes()
        this.listarTransportadora()
    }


    // Listagem de dados

    listar = () => {
        this.loadingVeiculos = true
        this.dadosTransportes = null
        this.service.Listar(this.placa, this.transpId !== "" ? this.transpId.value : "", this.clienteId !== "" ? this.clienteId.value : "").then(response => {
            if(response && response.data){
                this.dadosTransportes = response.data
                this.contarTotal()
            }
        }).catch(err => console.log(err)
        ).finally(() => this.loadingVeiculos = false)
    }

    listarClientes = () => {
        this.service.ListarClientes().then(response => {
            if(response && response.data){
                this.listaClientes = response.data.map(cliente => ({label: cliente.Nome, value: cliente.ClienteId}))
            }
        }).catch(err => console.log(err))
    }

    listarTransportadora = () => {
        this.service.ListarTransportadoras().then(response => {
            if(response && response.data){
                this.listaTranportadoras = response.data.map(transp => ({label: transp.ApelidoTransp, value: transp.TranspId}))
            }
        }).catch(err => console.log(err))
    }

    // Setar dados

    setPlaca = (value) => {
        this.placa = value
    }

    setTransportadora = (event) => {
        if(event) this.transpId = event
        else this.transpId = ""
    }

    setCliente = (event) => {
        if(event) this.clienteId = event
        else this.clienteId = ""
    }

    // Outras funções

    contarTotal = () => {
        const placas = Object.values(toJS(this.dadosTransportes))
        
        this.totalPlacas = 0

        placas.map(placa => {
            this.totalPlacas += placa.length
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/veiculos/stores/VeiculosStore.js